export default [ 'type', 'src', 'nonce', 'noModule' ];
